document.getElementById("downloadBtn").addEventListener("click", function(e) {
    e.preventDefault();
    const url = this.getAttribute("href");
    fetch(url)
      .then(res => res.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "FileDesign.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
});